import { Box, Typography } from '@mui/material';

import FooterPage from './footerPage';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NavBar from 'src/components/heroSection/navBar';
import { content } from 'src/common/lang/en-US';
import { getWorldMap } from 'src/resources/svgs/worldMap';

const AboutPage: React.FC = () => {
    const worldMap = getWorldMap('"rgba(115, 201, 216, 0.20)"');
    const encodedWorldMap = `data:image/svg+xml;base64,${btoa(worldMap)}`;

    return (
        <Box
            display="flex"
            flexDirection="column"
            minHeight="100vh"
            sx={{
                backgroundImage: `url(${encodedWorldMap})`,
                backgroundPosition: {
                    lg: '20rem 1rem',
                    md: '6rem 1rem',
                    sm: '4rem 1rem',
                    xl: '40rem 1rem',
                    xs: '2rem 1rem',
                },
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
            }}
        >
            <Box>
                <NavBar />
                <Box marginTop="120px" px={{ md: '3rem', xs: '2rem' }} py={{ md: '4rem', xs: '2rem' }}>
                    <Typography variant="h3" width={{ md: '70%', xs: '100%' }}>
                        {content.about.pageHeading}
                    </Typography>
                </Box>
            </Box>
            <Box
                bgcolor="white"
                flex={{ xl: 'unset', xs: 1 }}
                px={{ md: '3rem', xs: '2rem' }}
                py={{ md: '4rem', xl: '2rem', xs: '2rem' }}
            >
                <Typography color="text.black" marginBottom="30px" variant="h2">
                    {content.about.header}
                </Typography>
                <Typography color="text.black" variant="body2_Thin">
                    {content.about.subHeader}
                </Typography>

                <Box paddingTop={{ md: '30px', xl: '10px', xs: '20px' }}>
                    <Typography color="text.black" marginBottom="16px" variant="h2">
                        {content.aboutPage.header}
                    </Typography>
                    <Typography color="text.black" sx={{ alignItems: 'center', display: 'flex' }} variant="body2_Thin">
                        <LocationOnIcon sx={{ color: 'secondary.main' }} />
                        {content.aboutPage.subHeader}
                    </Typography>
                </Box>
            </Box>
            <FooterPage />
        </Box>
    );
};

export default AboutPage;
